import script from "./WorkspaceLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspaceLayout.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspaceLayout.vue?vue&type=style&index=0&id=917c6e3c&scoped=true&lang=less"

import exportComponent from "/Users/jeff/projects/js/pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-917c6e3c"]])

export default __exports__